import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone, Mail, Facebook, Instagram, MessageCircle } from "lucide-react";
import { SITE } from "../lib/site";

const navLinks = [
  { to: "/", label: "Home", id: "home" },
  { to: "/about", label: "About Us", id: "about" },
  { to: "/products", label: "Products", id: "products" },
  { to: "/contact", label: "Contact Us", id: "contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header className="sticky top-0 z-50 w-full" data-testid="site-header">
      {/* Top Utility Bar */}
      <div className="hidden md:block bg-brand-ink text-white text-xs">
        <div className="max-w-7xl mx-auto px-6 py-2 flex items-center justify-between">
          <div className="flex items-center gap-6">
            <a href={`tel:${SITE.phoneRaw}`} data-testid="top-phone" className="flex items-center gap-2 hover:text-brand-orange transition-colors">
              <Phone size={13} /> {SITE.phoneDisplay}
            </a>
            <a href={`mailto:${SITE.email}`} data-testid="top-email" className="flex items-center gap-2 hover:text-brand-orange transition-colors">
              <Mail size={13} /> {SITE.email}
            </a>
          </div>
          <div className="flex items-center gap-3">
            <a href={SITE.social.facebook} data-testid="top-fb" aria-label="Facebook" className="hover:text-brand-orange"><Facebook size={14} /></a>
            <a href={SITE.social.instagram} data-testid="top-ig" aria-label="Instagram" className="hover:text-brand-orange"><Instagram size={14} /></a>
            <a href={SITE.social.whatsapp} data-testid="top-wa" aria-label="WhatsApp" className="hover:text-brand-orange"><MessageCircle size={14} /></a>
          </div>
        </div>
      </div>

      {/* Main Nav */}
      <div className="bg-white/95 backdrop-blur-md border-b border-brand-line">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 sm:h-20 flex items-center justify-between">
          <Link to="/" data-testid="logo-link" className="flex items-center gap-3 group">
            <div className="h-14 sm:h-20 rounded-md flex items-center justify-center overflow-hidden pt-1">
              <img src="/assets/brand/logo.jpeg" alt="Desire Vet Care logo" className="w-auto h-full object-contain" />
            </div>
            {/* <div className="leading-tight">
              <div className="font-heading font-extrabold text-lg text-brand-orange tracking-tight">Desire</div>
              <div className="font-heading font-bold text-[10px] tracking-[0.18em] text-brand-ink -mt-0.5">VET CARE PVT. LTD.</div>
            </div> */}
          </Link>

          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                data-testid={`nav-${l.id}`}
                className={({ isActive }) =>
                  `font-heading font-semibold text-sm tracking-wide uppercase transition-colors ${
                    isActive ? "text-brand-orange" : "text-brand-ink hover:text-brand-orange"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <a
              href={SITE.whatsappBase}
              target="_blank"
              rel="noreferrer"
              data-testid="header-whatsapp-cta"
              className="bg-brand-green hover:bg-brand-greenDark text-white font-heading font-semibold text-sm px-5 py-2.5 rounded-md inline-flex items-center gap-2 transition-colors"
            >
              <MessageCircle size={16} /> WhatsApp
            </a>
          </nav>

          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden p-2 rounded-md text-brand-ink hover:bg-brand-surface"
            aria-label="Toggle menu"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {open && (
          <div className="lg:hidden border-t border-brand-line bg-white" data-testid="mobile-menu">
            <div className="px-6 py-4 space-y-1">
              {navLinks.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  end={l.to === "/"}
                  data-testid={`mobile-nav-${l.id}`}
                  className={({ isActive }) =>
                    `block py-3 px-3 font-heading font-semibold text-sm uppercase tracking-wide rounded-md ${
                      isActive ? "text-brand-orange bg-brand-surface" : "text-brand-ink hover:bg-brand-surface"
                    }`
                  }
                >
                  {l.label}
                </NavLink>
              ))}
              <a
                href={SITE.whatsappBase}
                target="_blank"
                rel="noreferrer"
                data-testid="mobile-whatsapp-cta"
                className="mt-2 bg-brand-green text-white font-heading font-semibold text-sm px-5 py-3 rounded-md flex items-center justify-center gap-2"
              >
                <MessageCircle size={16} /> Chat on WhatsApp
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};
